export class DeviceInfoHelper {
  public static getSimple() {
    return {
      userAgent: window.navigator.userAgent,
    };
  }
}
